<template>
    <v-app-bar :height="heightComputed" :fixed="phoneOnly" :absolute="pcOnly" class="navbar" :class="{'status-overlay-navbar': iosSafeArea, 'appbg': isAuthed && pcOnly, 'surface': !isAuthed || phoneOnly, 'is-app': capRunning}" app light flat>
        <div class="w-100" :class="{'fill-height': !iosSafeArea, 'd-flex flex-column': iosSafeArea}">
            <div v-if="iosSafeArea" class="status-overlay px-3 d-flex flex-row-reverse align-center w-100" style="height: 45px">
                <template v-if="!isProduction">
                    <v-spacer></v-spacer>
                    <v-icon small class="ms-1">mdi-wifi-strength-4</v-icon>
                    <v-icon small class="ms-1">mdi-signal-cellular-outline</v-icon>
                    <v-icon small class="ms-1">mdi-battery</v-icon>
                    <span class="details-text me-1">12:30</span>
                </template>
            </div>
            <v-container class="d-flex fill-height align-center flex-row" :class="{'px-1 py-0': !iosSafeArea, 'px-4 py-2': iosSafeArea}">
                <v-spacer v-if="phoneOnly && !isAuthed"></v-spacer>
                <div class="d-flex">
                    <div class="d-flex align-center justify-center">
                        <div v-if="isAuthed" class="d-flex align-center">
                            <v-btn v-if="phoneOnly && $route.meta && $route.meta.backButton" icon class="me-0 menu-button" @click="goBack">
                                <v-icon color="strong-text">mdi-arrow-left</v-icon>
                            </v-btn>
                            <v-btn v-else-if="phoneOnly" icon @click.prevent="$emit('menu')" class="me-0 menu-button">
                                <v-icon>mdi-menu</v-icon>
                            </v-btn>
                            
                            <div v-if="phoneOnly">
                                <h4 class="font-weight-semibold">{{routeName}}</h4>
                                <!-- <logo v-if="phoneOnly" link :height="44" /> -->
                            </div>
                            <div v-else class="d-flex align-center">
                                <v-btn v-if="$route.meta && $route.meta.backButton" width="40" height="40" icon class="me-1" @click="goBack">
                                    <v-icon color="strong-text">mdi-arrow-left</v-icon>
                                </v-btn>
                                <h4 class="font-weight-bold">{{routeName}}</h4>
                            </div>
                        </div>
                        <div v-else>
                            <logo link :height="pcOnly ? 50 : 44" />
                        </div>
                    </div>
                </div>
            <v-spacer />
                <div class="d-flex align-center">
                    <template v-if="isAuthed">

                        <inbox-button />

                        <v-btn icon outlined text :color="!newNotifications ? 'text' : 'primary'" depressed class="icon-wrapper me-2" :to="{name: 'notifications'}">
                            <v-badge class="notification-badge" :value="!!newNotifications" color="primary" bordered :content="newNotifications" overlap right>
                                <v-icon size="24">{{newNotifications ? 'mdi-bell' : 'mdi-bell-outline' }}</v-icon>
                            </v-badge>
                        </v-btn>
                    </template>
                    <div v-else-if="pcOnly" class="mx-3">
                        <v-btn class="ms-2" v-if="$route.name === 'login'"  :to="{name: 'register'}" outlined color="primary" depressed>Register</v-btn>
                        <v-btn v-if="$route.name !== 'login'" class="ms-3" :to="{name: 'login'}" color="primary" depressed>Sign in</v-btn>
                    </div>
                    
                    <user-nav v-if="isAuthed && pcOnly" :name="user.name" :avatar="user.avatar" />
                    
                </div>
            </v-container>
        </div>
        <v-progress-linear v-if="linearLoading" height="1" :active="linearLoading" :indeterminate="linearLoading" absolute top color="primary" ></v-progress-linear>

        <!-- <install-pwa-dialog v-if="pcOnly && !capRunning" v-model="pwaDialog" /> -->

    </v-app-bar>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import NotificationsMenu from './notifications-menu'
import NotificationsDialog from './notifications-dialog'
import InboxButton from './inbox-button'
import drawerRoutes from '@/helpers/links'



import Logo from '../logo'
// import Avatar from '../../default/avatar'
import UserNav from './user-nav'


export default {
    props: {
        height: {
            default: 80,
            type: Number
        }
    },
    data(){
        return {
            
        }
    },
    components: {
        Logo,
        NotificationsMenu,
        NotificationsDialog,
        UserNav,
        InboxButton,
        // Avatar,
    },
    computed: {
        newNotifications(){
            let unread = this.user.notifications_count;
            // let unread = 122;
            return unread > 99 ? '+99' : unread;
        },
        heightComputed(){
            let height = this.height;
            if (this.iosSafeArea){
                height += 45;
            }
            return height;
        },
        linearLoading(){
            return this.$store.state.globalModule.linearLoading;
        },
        routeName(){
            const routes = this.isTeacher ? drawerRoutes.auth.teacher : drawerRoutes.auth.student;
            const routeLink = routes.find(route=>route.name === this.$route.name);
            return routeLink ? routeLink.text : this.$route.meta.title;
        },
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods,

        goBack(){
            this.$router.go(-1);
            // this.$router.push({path: '/'});
        },
    }
}
</script>

<style lang="scss" scoped>
    .navbar{
        .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before{
            opacity: 0!important;
        }

        &.surface{

            box-shadow: none!important;
            border-bottom: 1px solid rgba(#000, 0.1)!important;
            // &.is-app{
            // }
        }

        @media(max-width: 700px){
            .v-toolbar__content .v-btn--icon.menu-button {
                margin: 0 -10px;
            }
        }
        .status-overlay{
            // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
    }
</style>
<style lang="scss">
.status-overlay-navbar{
    .v-toolbar__content{
        padding: 0!important;
        align-items: start!important;
    }
}
</style>